import { ServiceManager, ServiceBusController } from '@estee/elc-service';
import { events, on, queryProvider, serviceQueries } from '@estee/elc-service-bus';

const queries = [
    [serviceQueries.GET_PRODUCT_DATA, 'getProductData'],
    [serviceQueries.GET_PRODUCTS, 'getProductSkus'],
    [serviceQueries.GET_PRODUCTS_V2, 'getProductsV2'],
    [serviceQueries.GET_PRODUCTS_V3, 'getProductsV3'],
    // @todo remove on MPPFIND-4454
    [serviceQueries.PAGE_VIEW_TRACK_PRODUCT_GRID, 'getAnalyticsDataForProductGrid'],
    // @todo remove on MPPFIND-4454
    [serviceQueries.PAGE_VIEW_TRACK_PRODUCT_FULL, 'getAnalyticsDataForProductFull'],
    [serviceQueries.GET_SKUS, 'getSkus'],
    [serviceQueries.GET_REVIEW_PRODUCT, 'getReviewProduct'],
    [serviceQueries.GET_SORTBY_VALUE, 'getSortbyValue']
];

const onEvents = [[events.NAVIGATE, 'productRouting']];
export class ServiceBus extends ServiceBusController {
    @on(events.ECOMM_STARTED, { replay: true })
    public onEcommStarted = () => {
        queries.forEach(ServiceManager.setDecoratorOnFunction(queryProvider));
        onEvents.forEach(ServiceManager.setDecoratorOnFunction(on));
    };
}

/* eslint-disable  @typescript-eslint/no-explicit-any */
type ServiceBusControllerBody = { [key: string]: Promise<(...args: any[]) => any> | Function };
// @ts-ignore
export const serviceBusBaseClass = new ServiceBus() as ServiceBusController &
    ServiceBusControllerBody;
